import { CONTENT_IMAGE_PATH, DOCUMENTS_PATH } from '@shared/config/paths/paths';

export const getImageUrl = (imageValue?: string) => {
  if (!imageValue) {
    return '';
  }

  if (imageValue.split('/').length > 1) {
    return `${DOCUMENTS_PATH}/${imageValue}`;
  }

  return imageValue ? `${CONTENT_IMAGE_PATH}/${imageValue.toString()}/original.png` : '';
};
